import { useEffect, useRef } from "react";
import { useRecoilState } from "recoil";
import { useQuery, useSubscription } from "@apollo/react-hooks";
import { MY_HR_EMPLOYEE_SUBSCRIPTION, MY_HR_GET_EMPLOYEE } from "my-hr/graphql";
import { myHrTempDataState } from "my-hr/states";
import { useOcPolling } from "oc/hooks";

export const useMyHrEmployee = ({ employeeId }: { employeeId: string }) => {
  const [crTempData, setCrTempData] = useRecoilState(myHrTempDataState);
  const hasSetTempDataRef = useRef(false);

  const pollInterval = useOcPolling(1000 * 60);

  const { data, loading, error, refetch } = useQuery(MY_HR_GET_EMPLOYEE, {
    fetchPolicy: "cache-and-network",
    skip: !employeeId,
    pollInterval,
    variables: { code: employeeId },
  });

  // Handle data initialization via useEffect
  useEffect(() => {
    if (data?.employee && !crTempData && !hasSetTempDataRef.current) {
      hasSetTempDataRef.current = true;
      setCrTempData(data.employee);
    }
  }, [data, crTempData, setCrTempData]);

  // Reset ref when employeeId changes
  useEffect(() => {
    hasSetTempDataRef.current = false;
  }, [employeeId]);

  useSubscription(MY_HR_EMPLOYEE_SUBSCRIPTION, {
    fetchPolicy: "network-only",
    onData: () => refetch(),
    onError: (subscriptionError) => {
      console.error({
        component: "useEmployee",
        errorDescription:
          "Error occurred when subscribing to MY_HR_EMPLOYEE_SUBSCRIPTION",
        error: subscriptionError,
      });
    },
  });

  return { data: data?.employee, loading, error };
};

export default useMyHrEmployee;
